// extracted by mini-css-extract-plugin
module.exports = {"root":"X_b4","icon":"X_bj","main-search-icon":"X_c4","mainSearchIcon":"X_c4","label-icon-default-filled":"X_c5","labelIconDefaultFilled":"X_c5"};